import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { CellContext } from '@tanstack/react-table';

export interface ChargePointListChannelsCellProps
  extends CellContext<
    GatewayChargePointModel,
    GatewayChargePointModel['channels']
  > {}

export const ChargePointListChannelsCell = (
  props: ChargePointListChannelsCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="row" gap={GapEnum.S}>
      <Text>{getValue().length}</Text>
    </Stack>
  );
};
